var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 311,
    viewBox: "0 0 250 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_4317)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.95 14.5H0V161.74C0 162.782 0.414052 163.782 1.15107 164.519C1.88809 165.256 2.8877 165.67 3.93 165.67H246.03C247.071 165.667 248.068 165.252 248.802 164.515C249.537 163.779 249.95 162.781 249.95 161.74V14.5Z",
    fill: "#EBF1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.02 6.15002H3.92C2.87943 6.15267 1.88239 6.56789 1.14753 7.30462C0.412676 8.04136 -3.36864e-06 9.03945 0 10.08L0 14.5H249.95V10.08C249.95 9.03772 249.536 8.03811 248.799 7.30109C248.062 6.56408 247.062 6.15002 246.02 6.15002",
    fill: "#BBC7D9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00005 10.67C7.00005 11.028 6.85782 11.3714 6.60464 11.6246C6.35147 11.8778 6.00809 12.02 5.65005 12.02C5.29201 12.02 4.94863 11.8778 4.69545 11.6246C4.44228 11.3714 4.30005 11.028 4.30005 10.67C4.30005 10.312 4.44228 9.96859 4.69545 9.71541C4.94863 9.46224 5.29201 9.32001 5.65005 9.32001C6.00809 9.32001 6.35147 9.46224 6.60464 9.71541C6.85782 9.96859 7.00005 10.312 7.00005 10.67ZM11.7 10.67C11.7 11.0254 11.5589 11.3662 11.3076 11.6175C11.0563 11.8688 10.7154 12.01 10.36 12.01C10.0047 12.01 9.66382 11.8688 9.41253 11.6175C9.16123 11.3662 9.02005 11.0254 9.02005 10.67C9.02005 10.3133 9.16175 9.97119 9.41399 9.71895C9.66623 9.46671 10.0083 9.32501 10.365 9.32501C10.7218 9.32501 11.0639 9.46671 11.3161 9.71895C11.5683 9.97119 11.71 10.3133 11.71 10.67M16.42 10.67C16.42 10.8466 16.3853 11.0215 16.3177 11.1847C16.2501 11.3479 16.151 11.4962 16.0261 11.6211C15.9012 11.746 15.7529 11.845 15.5898 11.9126C15.4266 11.9802 15.2517 12.015 15.075 12.015C14.8984 12.015 14.7235 11.9802 14.5603 11.9126C14.3972 11.845 14.2489 11.746 14.124 11.6211C13.9991 11.4962 13.9 11.3479 13.8324 11.1847C13.7648 11.0215 13.73 10.8466 13.73 10.67C13.73 10.312 13.8723 9.96859 14.1255 9.71541C14.3786 9.46224 14.722 9.32001 15.08 9.32001C15.4381 9.32001 15.7815 9.46224 16.0346 9.71541C16.2878 9.96859 16.43 10.312 16.43 10.67",
    fill: "#ABB9CB"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3099 114.4V52.64L21.5999 114.4H66.2999H66.3099ZM72.6099 140.59H69.9299C67.9299 140.59 66.3099 138.97 66.3099 136.97V120.7H17.3099C15.3099 120.7 13.6899 119.08 13.6899 117.08V115.58C13.6899 114.81 13.9299 114.07 14.3899 113.45L65.0999 43.52C65.436 43.0548 65.8779 42.6762 66.389 42.4154C66.9002 42.1546 67.4661 42.0191 68.0399 42.02H68.9899C70.9899 42.02 72.6099 43.64 72.6099 45.64V114.4H84.7099V120.7H72.6099V140.59ZM95.2999 90.07C95.2999 112.06 100.86 134.29 124.46 134.29C147.92 134.29 153.61 111.69 153.61 90.07C153.61 67.71 148.17 45.97 124.46 45.85C100.49 46.1 95.3099 67.47 95.3099 90.07M88.8799 90.07C88.8799 64.01 96.5399 39.43 124.46 39.43C152.12 39.43 160.03 64.38 160.03 90.07C160.03 116.01 151.88 139.72 124.46 140.59C96.9099 139.72 88.8799 116.38 88.8799 90.07M216.81 114.4V52.64L172.1 114.4H216.81ZM97.3499 116.26H95.2999V120.7H46.9399C46.381 120.701 45.8273 120.592 45.3105 120.379C44.7937 120.166 44.324 119.854 43.9283 119.459C43.5326 119.064 43.2186 118.595 43.0044 118.079C42.7902 117.562 42.6799 117.009 42.6799 116.45V115.78C42.6799 114.88 42.9699 114.01 43.4899 113.28L93.9099 43.78C94.436 43.0488 95.1807 42.5036 96.0367 42.2231C96.8927 41.9427 97.8157 41.9414 98.6724 42.2196C99.5292 42.4978 100.275 43.0409 100.803 43.7707C101.331 44.5005 101.614 45.3792 101.61 46.28V114.4H113.71V120.7H101.61V136.33C101.61 138.68 99.6999 140.59 97.3499 140.59V116.26Z",
    fill: "#ABB9CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 140.59H216.81V135.23H69V140.59Z",
    fill: "#ABB9CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.05 97.79H167.43V57.67H133.05V97.79Z",
    fill: "#EBF1F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.75 52.47L143.64 54.1L143.15 63.36L98.75 70.65V52.47",
    fill: "#F3BCA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.61 135.5C130.61 135.5 147.31 216.53 144.18 228.7C141.05 240.87 83.9999 285.1 83.9999 285.1L72.8999 274.6C94.4599 248.35 96.7999 237.65 120.19 224.53C101.53 198.5 80.2099 173.47 82.2899 139.68L130.62 135.5",
    fill: "#13182E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.27 139.68C81.42 165.53 86.39 195.33 90.97 224.88C84.95 250.38 89.87 276.67 93.75 301.34H109.05L111.14 225.22C121.28 198.29 128.94 166.12 130.61 135.5C120.77 146.11 104.23 146.88 82.27 139.68",
    fill: "#2B2C45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.28 301C109.28 301 123.56 305.65 123.56 310.08H93.1001C92.8501 306.08 92.9801 304.05 93.9701 301H109.27",
    fill: "#19243E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3601 49.52L93.2301 28.92L107.31 35.7C107.31 35.7 103.14 45.87 103.14 54.74C103.14 63.6 84.3601 49.52 84.3601 49.52Z",
    fill: "#E4A69A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4 46.91C73.74 50.93 72.54 75.61 74.28 85.77C76.02 95.94 86.8 121.24 86.8 124.72C86.8 128.2 82.27 139.68 82.27 139.68C86.14 153.18 123.93 163.43 135.31 151.48C138.87 126.53 118.31 35.56 85.41 46.91",
    fill: "#1E5DAE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7799 136.29C83.7799 136.29 114.95 147.46 135.99 141.18L135.66 151.14C135.66 151.14 119.11 158.69 82.5299 146.44C82.5299 146.44 80.0299 139.84 83.7799 136.29Z",
    fill: "#F9C751"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.99 168.28L95.3501 165.14L98.3501 143.51L120.98 146.65L117.99 168.28Z",
    fill: "#EFA62E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.04 168.28L95.3999 165.15L97.6599 148.85L120.29 151.99L118.04 168.28",
    fill: "#F9C751"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.44 156.98L103.05 154.99L103.43 152.25L117.82 154.24L117.44 156.98Z",
    fill: "#EFA62E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8501 191.13L96.5301 191.64L101.67 154.54L97.9901 154.03L92.8501 191.13Z",
    fill: "#D6E1EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.98 191.01L97.22 191.73L99.7 173.77L94.47 173.05L91.98 191.01Z",
    fill: "#1887FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9599 146.12C93.0919 146.564 93.3488 146.96 93.6999 147.261C94.051 147.563 94.4815 147.757 94.9399 147.82L95.5899 147.92C96.5599 148.05 97.4699 147.58 97.9599 146.82L103.41 147.57C109.36 148.17 111.76 159.59 111.76 159.59L109.51 159.28C109.51 159.28 107.63 153.36 105.42 152.99C103.22 152.62 102.42 154.77 102.42 154.77L96.9599 154.01C96.8286 153.568 96.5732 153.173 96.224 152.871C95.8748 152.57 95.4465 152.375 94.9899 152.31L94.3299 152.21C93.8715 152.149 93.4052 152.221 92.9868 152.418C92.5683 152.615 92.2153 152.928 91.9699 153.32L87.6399 152.72L88.6399 145.52L92.9599 146.12M95.7799 160.27L103.28 161.31L103.67 158.52L96.1599 157.49L95.7799 160.27Z",
    fill: "#ABB9CB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.52 136.53C102.82 136.53 100.16 136.18 97.7599 135.31C92.6799 133.47 90.9299 126.97 89.0399 122.41C84.5999 111.73 82.9799 99.78 82.1199 88.31C81.3999 78.69 82.4199 68.56 88.8399 60.89C88.9199 60.95 88.9999 60.99 89.1099 61.02C93.6399 62.1 98.7399 65.65 102.27 68.7C106.02 71.92 108.89 76.23 111.04 80.65C115.79 90.4 114.91 101.51 116.47 112.02C116.52 112.35 116.83 112.56 117.14 112.56H117.22C121.92 112.06 126.28 109.92 130.85 108.94C132.305 115.184 133.48 121.491 134.37 127.84C127.98 130.84 121.57 133.8 114.69 135.39C111.686 136.112 108.61 136.494 105.52 136.53",
    fill: "#C9DDF3"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8199 37.07C96.8199 37.07 99.2799 45.47 109.07 46.09L112.87 40.27L116.57 39.22L115.33 27.04C115.33 27.04 112.39 17.74 102.74 16.3C93.0899 14.87 86.0699 30.6 96.8199 37.07",
    fill: "#F3BCA9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8699 31.28C87.9899 30.49 88.0399 29.18 88.2399 28.23C86.8399 27.34 86.8499 26.69 86.2599 25C85.8087 23.7096 85.7128 22.3216 85.9825 20.9815C86.2521 19.6414 86.8773 18.3984 87.7926 17.383C88.7078 16.3676 89.8793 15.6171 91.1843 15.2101C92.4893 14.8032 93.8797 14.7548 95.2099 15.07C95.4599 5.06999 116.41 3.44999 120.31 16.81C121.78 17.45 120.33 19.01 120.91 20.64C122 23.75 123.03 26.81 119.92 27.91C118.92 28.26 117.88 28.31 116.9 28.14C115.5 28.04 113.89 27.69 112.25 27.04L112.09 26.97C109.65 26.16 107.31 24.43 107.43 24.5C107.43 24.5 110.8 28.63 101.9 34.47C92.9999 40.31 87.0599 36.63 87.8699 31.28",
    fill: "#19243E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.97 39.35C97.97 39.35 92.88 30.98 96.93 28.99C100.97 27 102.13 36.09 102.13 36.09L97.97 39.35Z",
    fill: "#EAB5AA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.97 94.14C151.8 94.14 151.637 94.0726 151.517 93.9526C151.397 93.8325 151.33 93.6698 151.33 93.5V83.74C151.319 83.6499 151.327 83.5585 151.353 83.4717C151.38 83.385 151.425 83.3049 151.485 83.2368C151.545 83.1687 151.619 83.1142 151.702 83.0768C151.784 83.0395 151.874 83.0202 151.965 83.0202C152.056 83.0202 152.145 83.0395 152.228 83.0768C152.311 83.1142 152.385 83.1687 152.445 83.2368C152.505 83.3049 152.55 83.385 152.577 83.4717C152.603 83.5585 152.611 83.6499 152.6 83.74V93.5C152.6 93.85 152.32 94.14 151.97 94.14M159.19 94.14C159.02 94.14 158.857 94.0726 158.737 93.9526C158.617 93.8325 158.55 93.6698 158.55 93.5V83.74C158.539 83.6499 158.547 83.5585 158.573 83.4717C158.6 83.385 158.645 83.3049 158.705 83.2368C158.765 83.1687 158.839 83.1142 158.922 83.0768C159.004 83.0395 159.094 83.0202 159.185 83.0202C159.276 83.0202 159.365 83.0395 159.448 83.0768C159.531 83.1142 159.605 83.1687 159.665 83.2368C159.725 83.3049 159.77 83.385 159.797 83.4717C159.823 83.5585 159.831 83.6499 159.82 83.74V93.5C159.82 93.85 159.54 94.14 159.19 94.14",
    fill: "#ABB9CB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.41 91.07V95.67C148.41 97.1747 149.007 98.6179 150.07 99.6828C151.133 100.748 152.575 101.347 154.08 101.35H157.26C158.763 101.347 160.204 100.749 161.266 99.6864C162.329 98.6236 162.927 97.183 162.93 95.68V91.08C162.93 90.36 162.35 89.78 161.63 89.78H149.71C148.99 89.78 148.41 90.36 148.41 91.08",
    fill: "#FFFFFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2099 71.82C86.4399 44.1 106.69 59.31 110.91 68.8C115.34 78.77 111.03 110.28 111.03 110.28L142.58 103.73L144.69 116.59C144.69 116.59 109.26 137.36 99.2399 130.45C89.1999 123.54 80.7799 81.2 82.1999 71.82",
    fill: "#F3BCA9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.62 105.3C112.62 96 114.24 76.3 110.91 68.8C106.69 59.3 86.4399 44.1 82.2099 71.82C81.3699 77.32 83.9099 94.09 88.1799 108.44C95.9999 107.47 103.81 106.38 111.62 105.29",
    fill: "#1887FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.58 103.73C142.58 103.73 152.44 96.17 159.33 99.65C166.23 103.14 167.57 109.14 163.2 111.19C158.83 113.25 152.83 114.6 150.8 114.47C148.78 114.34 144.7 116.59 144.7 116.59L142.58 103.73Z",
    fill: "#F3BCA9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.49 99.16C152.49 99.16 164.13 96.33 165.71 100.59C166.52 102.79 159.23 101.17 159.23 101.17L152.49 99.16Z",
    fill: "#F3BCA9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.06 76.19L146.08 71.69C145.765 70.2224 146.043 68.6896 146.854 67.4267C147.666 66.1637 148.944 65.2733 150.41 64.95L153.52 64.27C154.988 63.9546 156.52 64.2331 157.783 65.0444C159.046 65.8558 159.937 67.1341 160.26 68.6L161.24 73.1C161.39 73.8 160.94 74.5 160.24 74.65L148.6 77.18C148.263 77.2512 147.912 77.1858 147.623 76.9984C147.334 76.8109 147.132 76.5166 147.06 76.18",
    fill: "#FFFFFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.1 64C159.19 63.68 159.24 63.27 159.27 62.8C159.67 58.88 158.63 54.34 157.17 53.79C157.02 53.7321 156.866 53.6853 156.71 53.65C156.597 53.6266 156.484 53.6066 156.37 53.59L156.27 53.57C156.107 53.5426 155.944 53.5192 155.78 53.5H155.68L155.22 53.46L155.08 53.45L154.48 53.42L153.81 53.41H152.98C148.88 53.46 143.64 54.1 143.64 54.1L143.14 63.36C143.14 63.36 148.51 68.46 154.81 68.73H154.91C160.81 69.54 165.24 68.13 159.11 63.99",
    fill: "#F3BCA9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.72 19.48C117.47 20.54 117.21 21.6 116.93 22.66L88.3799 13.74C91.6799 4.14001 101.56 -1.37999 110.61 1.44001C114.485 2.67144 117.777 5.27414 119.87 8.76001C118.92 12.28 118.53 15.92 117.72 19.48Z",
    fill: "#EFA62E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8601 17.4C89.4201 7.09002 100.03 1.16002 109.76 4.20002C119.48 7.24002 124.72 19.74 121.76 30.25L85.8701 17.4",
    fill: "#F9C751"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.4 31.66L85.21 19.73C84.56 19.53 84.21 18.79 84.42 18.08C84.64 17.38 85.36 16.98 86.01 17.18C86.01 17.18 125.18 30.05 124.96 30.75C124.74 31.45 124.03 31.86 123.38 31.66",
    fill: "#EFA62E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9999 285.1C83.9999 285.1 89.0599 294.34 86.9399 301.34L66.1799 282.12L72.8799 274.6L83.9999 285.1Z",
    fill: "#19243E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.8 310.42H206.58C207.496 310.418 208.402 310.228 209.242 309.863C210.082 309.499 210.839 308.966 211.466 308.299C212.094 307.631 212.578 306.843 212.89 305.981C213.202 305.12 213.334 304.204 213.28 303.29H149.1C149.046 304.205 149.179 305.122 149.491 305.984C149.804 306.846 150.289 307.635 150.917 308.302C151.545 308.97 152.304 309.502 153.145 309.866C153.986 310.23 154.893 310.419 155.81 310.42",
    fill: "#FFFFFE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.34 212.86L175.94 231.56H199.67L194.27 212.86C193.884 211.447 193.039 210.202 191.867 209.322C190.696 208.442 189.265 207.977 187.8 208C186.337 207.979 184.908 208.445 183.739 209.325C182.569 210.205 181.726 211.448 181.34 212.86",
    fill: "#9BCAFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.14 255.13H206.47L199.67 231.57H175.94L169.14 255.13",
    fill: "#D9E8F7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.34 278.7H213.27L206.47 255.13H169.14L162.34 278.7",
    fill: "#9BCAFC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.27 278.7H162.34L155.95 300.8C155.81 301.3 155.74 301.78 155.71 302.26H219.91C219.87 301.78 219.8 301.29 219.66 300.81L213.27 278.7",
    fill: "#D9E8F7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.04 309.4H147.57C146.623 309.4 145.715 309.024 145.046 308.354C144.376 307.685 144 306.777 144 305.83C144 304.883 144.376 303.975 145.046 303.306C145.715 302.636 146.623 302.26 147.57 302.26H228.04C228.987 302.26 229.895 302.636 230.564 303.306C231.234 303.975 231.61 304.883 231.61 305.83C231.61 306.777 231.234 307.685 230.564 308.354C229.895 309.024 228.987 309.4 228.04 309.4",
    fill: "#9BCAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_4317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 311,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.fc5fc2333704509aa77320c3bc46dc9d.svg";
export { ForwardRef as ReactComponent };